import React, { useEffect, ReactElement, CSSProperties, RefObject } from "react";

// 1. Define the shape of your Links and Props
interface ContentLink {
  text: string;
  url?: string; // Add other fields if necessary
}

interface TipModalProps {
  headerText: string;
  content: string;
  contentLinks?: ContentLink[];
  showModalTip: (show: boolean) => void;
  buttonRef: RefObject<HTMLButtonElement | HTMLDivElement | null>;
  modalRef: RefObject<HTMLDivElement | null>;
  modal: 'hireos' | 'worklife' | 'roletype' | 'roleimpact' | string;
  top: number | string;
  left: number | string;
  showHireOSRole: (show: boolean) => void;
}

export default function TipModal(props: TipModalProps): ReactElement {
  const {
    headerText,
    content,
    contentLinks,
    showModalTip,
    buttonRef,
    modalRef,
    modal,
    top,
    left,
    showHireOSRole
  } = props;

  const handleLearnProfilesClick = (): void => {
    showHireOSRole(true);
    showModalTip(false);
  };

  useEffect(() => {
    // 2. Type the event as a MouseEvent
    const handleClickOutside = (event: MouseEvent): void => {
      const target = event.target as Node;
      
      // Check if click is outside both the triggering button and the modal itself
      if (
        buttonRef.current && !buttonRef.current.contains(target) &&
        modalRef.current && !modalRef.current.contains(target)
      ) {
        showModalTip(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [buttonRef, modalRef, showModalTip]);

  // 3. Use CSSProperties for the styles object
  const styles: Record<string, CSSProperties> = {
    toolTipModal: {
      backgroundColor: "#FFF",
      width: 402,
      top: top,
      left: left,
      position: "fixed",
      transform: (modal === 'worklife' || modal === 'roleimpact') ? "translateX(-70%)" : "translateX(-50%)",
      boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.40)",
      borderRadius: 24,
      display: "block",
      padding: "8px 8px 16px 8px",
      flexDirection: "column",
      alignItems: "center",
      gap: 16
    },
    toolTipHeaderText: {
      color: "#FFF", // Note: Your inline comment said Primary-Text, check if this should be a var
      fontFamily: "Inter",
      fontSize: 16,
      fontStyle: "normal",
      fontWeight: 600,
      marginLeft: 8
    },
    tipModal: {
      position: "fixed",
      top: modal === "hireos" ? 222 : modal === "worklife" ? 243 : 306,
      left: modal === "hireos" ? "44%" : modal === "worklife" ? 255 : modal === "roletype" ? 175 : 255,
      zIndex: 999,
      width: 12,
      height: 7
    },
  };

  return (
    <div style={styles.toolTipModal}>
      <div className='tool-tip-modal' ref={modalRef}>
        <div className='tip-modal-header' style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: "flex", justifyContent: 'flex-start' }}>
            <div className='modal-info-icon'></div>
            <div style={styles.toolTipHeaderText}>{headerText}</div>
          </div>
          <button 
            className='modal-close-icon'
            onClick={() => showModalTip(false)}
          ></button>
        </div>
        <div style={{ backgroundColor: 'white', marginTop: 16 }}>
          <p style={{ marginRight: 6, marginLeft: 6 }}>{content}</p>
          <div style={{ height: 16 }}></div>
          {contentLinks && contentLinks.map((link, index) => (
            <button 
              key={index} 
              style={{ color: "blue", marginRight: 6, marginLeft: 6, background: 'none', border: 'none', cursor: 'pointer' }}
              onClick={() => handleLearnProfilesClick()}
            >
              {link.text}
            </button>
          ))}
        </div>
      </div>
      <div className="modal-tip" style={styles.tipModal}></div>
    </div>
  );
}